module.exports = __webpack_public_path__ + "img/3.8622ee41.jpg";